@use 'src/globals/main';

pn-header {
  display: block;
  h1 {
    color: main.$gray900;
    margin: 0;
  }

  p {
    color: main.$gray700;
    margin: 0;
  }
}

pn-header .pn-header {
  &-breadcrumbs {
    width: 100%;
  }
  &-container {
    position: relative;
    width: 100%;
    max-width: var(--max-width);
    margin: 0 auto;
    padding: clamp(1em, 3vw, 2em) clamp(0.5em, 3vw, 2em);

    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1.5em;

    > pn-text-link {
      display: block;
    }
  }

  &-content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 1em;
  }

  [slot='buttons'] {
    display: flex;
    flex-direction: column;
    gap: 1em;
  }
}
